import { Direction } from '@material-ui/core/styles';

export const initializeDirection = (value?: Direction): Direction | undefined => {
  return value;
};
